// Generated from docs/design/tokens.json. Do not edit by hand.
export const SHEET = {
  "topInsetPx": 24,
  "handleWidthPx": 42,
  "handleHeightPx": 5,
  "cornerRadiusPx": 28,
  "singleColumnPx": 680,
  "enterDurationMs": 260,
  "exitDurationMs": 200,
  "spring": {
    "mass": 1,
    "stiffness": 320,
    "damping": 32
  },
  "settleMaxDurationMs": 800,
  "decelerationRate": 0.998,
  "rubberBandLimitPx": 80,
  "rubberBandRatio": 0.55,
  "minExpansionPx": 40,
  "tapSlopPx": 8
} as const;
export const HANDOFF = {
  "foregroundDurationMs": 3000,
  "returnFallbackMs": 5000
} as const;
export const CELEBRATION = {
  "popDurationMs": 480,
  "revealDurationMs": 320,
  "confettiDurationMs": 1600,
  "inviteDelayMs": 900,
  "doneExitDurationMs": 160,
  "inviteEnterDurationMs": 560
} as const;
